import { DateCalendar as MuiDateCalendar, DateCalendarProps } from "@mui/x-date-pickers"

import cx from "classnames"

import "./calendar.scss"

export default function Calendar(props: DateCalendarProps) {
  // views 는 외부에서 override 가능하도록 default 만 부여 (기존 사용처 호환)
  const { views = ["year", "month", "day"], className, ...rest } = props

  return (
    <MuiDateCalendar
      monthsPerRow={3}
      yearsPerRow={4}
      fixedWeekNumber={6}
      showDaysOutsideCurrentMonth
      slotProps={{
        day: {
          className: "calendar-day",
        },
        monthButton: {
          className: "calendar-month-button",
        },
        yearButton: {
          className: "calendar-year-button",
        },
        switchViewIcon: {
          className: `calendar-switch-view-icon`,
        },
      }}
      {...rest}
      views={views}
      className={cx("CalendarCont", className)}
    />
  )
}
